exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.vc-photoshop {\n  background: #FFF;\n  box-shadow: none;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  box-sizing: initial;\n  width: 513px;\n  font-family: \"Nunito\", sans-serif;\n  margin: 30px auto;\n}\ndiv.vc-ps-head{\n  display: none;\n}\ndiv.vc-hue-picker{\n  width: 15px;\n}\n", ""]);

// exports
